export default __webpack_public_path__ + "static/media/model_y.30acb76a.jpeg";